import { render } from "./RulesList.vue?vue&type=template&id=8b02506a"
import script from "./RulesList.vue?vue&type=script&lang=js"
export * from "./RulesList.vue?vue&type=script&lang=js"

import "./RulesList.vue?vue&type=style&index=0&id=8b02506a&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.9.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__